import type { Currency } from '@repo-level/core-front';
import { amountWithCurrencySymbol } from './currency';

export const getCurrencyCentsAndCode = (
  amount: number,
  currency: string,
  currencies: Currency[]
): { currency: string; amount: number } => {
  const currentCurrency = currencies.find(({ code }) => code === currency);

  if (!currentCurrency) return { amount, currency };

  const { subunitsToUnit, subcurrencies } = currentCurrency;

  if (amount <= subunitsToUnit && subcurrencies.length !== 0)
    return {
      amount: amount / subcurrencies[0].subunitsToUnit,
      currency: subcurrencies[0].code,
    };

  return { amount: amount / subunitsToUnit, currency };
};

export const formatWalletValue = (
  currencyCode: string,
  amountCents: number,
  currencies: Currency[],
  withSymbol?: boolean
) => {
  const { amount, currency } = getCurrencyCentsAndCode(
    amountCents,
    currencyCode,
    currencies
  );

  if (!withSymbol) return amount;

  return amountWithCurrencySymbol(currency, amount);
};
